import React, { useState, useEffect } from 'react'
import Student_Header from '../student_header/Student_Header'
import { StudentSupport, StudentSupportList } from '../../../../api/Student'
import { ProfileSections } from '../../../../api/Auth'
import Table from 'react-bootstrap/Table';
import Student_Footer from '../student_footer/Student_Footer';
import { BiSupport } from "react-icons/bi";
import { Link, useNavigate } from 'react-router-dom';

const Student_Support = () => {
    const navigate = useNavigate();
    const [userProfile, setuserProfile] = useState([])
    const [First_name, setFirst_Name] = useState("")
    const [Last_name, setLast_Name] = useState("")
    const [Email, setEmail] = useState("")
    const [Phone, setPhone] = useState("")
    const [Query, setQuery] = useState("")
    const [support_file, setSupport_file] = useState("")
    const [SupportList, setSupportList] = useState([]);

    const user_id = localStorage.getItem("User_id");
    // <------- User Authentication token's ------------>
    const token = localStorage.getItem("User_Token");
    const headers = {
        "Authorization": `Bearer ${token}`
    };

    const GetProfileSection = async () => {
        const data = {
            user_id: user_id
        }
        try {
            const response = await ProfileSections(data, headers)
            setuserProfile(response?.data.data?.profile)
        } catch (error) {
            console.log("error", error)
        }
    }
    console.log("GetProfileSection", userProfile)

    const HandleSupportSubmit = async (e) => {
        e.preventDefault();
        const newformData = new FormData();
        newformData.append("user_type","student")
        newformData.append("user_query",Query)
        newformData.append("support_file",support_file)
        // const data = {
        //     user_type: "student",              //'interviewer, trainer, student'
        //     user_query: Query,
        //     support_file: support_file,
        // }
        try {
            const response = await StudentSupport(newformData, headers)
            console.log("HandleSupportSubmit", response)
            if(response?.data?.statusCode == "200"){
                alert("Succesfully Post the Query")
            }
            setQuery("")
        }
        catch (error) {
            console.log("error", error)
        }
        console.log({ First_name, Last_name, Email, Phone, Query })
    }

    const GetStudentSupportList = async () => {
        try {
            const response = await StudentSupportList(headers)
            if (response?.data?.statusCode == 401) {
                localStorage.clear();
                navigate("/Signin")
                window.location.reload()
              }
            setSupportList(response?.data?.data)
        } catch (error) {
            console.log("error", error)
        }
    }
    console.log("GetStudentSupportList", SupportList)
    useEffect(() => {
        GetProfileSection();
        GetStudentSupportList();
    }, [])

    // Scroll to the top of the page when the component is rendered
    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);

    return (
        <>
            <div className="bg_nav-slid bg-white">
                {/* <------- This is the Student Header section's here -----------> */}
                <Student_Header />
            </div>
            <div className="header_space"></div>
            <div className='support_sec py-3'>
            <div className='container'>
                <div className='col-md-8 mx-auto shadow-lg'>
                    <div className='supportFormcontainer p-md-4'>
                    <div className='section-title text-center'>
                        <h3> <BiSupport /> Support</h3>
                    </div>

                    <form className='form' onSubmit={HandleSupportSubmit}>
                        <div className='row'>
                        <div className='col-md-6 mt-4'>
                            <label htmlFor="">First Name</label>
                            <div className="form-floating form-group">
                                <input type="text" value={userProfile?.fname} className="form-control"
                                    id="floatingInput" placeholder=""
                                    name="First_name"
                                />
                            </div>
                        </div>
                        <div className='col-md-6 mt-4'>
                            <label htmlFor="floatingInput">Last Name</label>
                            <div className="form-floating form-group">
                                <input type="text" value={userProfile?.lname} className="form-control"
                                    id="floatingInput" placeholder=""
                                    name="Last_name"
                                />
                            </div>
                        </div>
                        <div className='col-md-6 mt-4'>
                            <label htmlFor="floatingInput">Email</label>
                            <div className="form-floating form-group">
                                <input type="text" className="form-control" value={userProfile.email}
                                    id="floatingInput" placeholder=""

                                />
                            </div>
                        </div>
                        <div className='col-md-6 mt-4'>
                            <label htmlFor="floatingInput">Phone</label>
                            <div className="form-floating form-group">
                                <input type="text" className="form-control" value={userProfile?.mobile?.replace(/null/g, '')}
                                    id="floatingInput" placeholder=""
                                />
                            </div>
                        </div>
                        <div className='col-md-12 mt-4'>
                            <label htmlFor="floatingInput">PDF:</label>
                            <div className="form-group">
                                <input type="file" className="form-control" name='support_file'
                                onChange={(e) => setSupport_file(e.target.files[0])}
                                    id="floatingInput" placeholder=""
                                />
                            </div>
                        </div>
                        <div className='col-md-12 mt-4'>
                            <div className="form-floating form-group">
                                <textarea rows={5}
                                    cols={60} type="text" value={Query} onChange={(e) => setQuery(e.target.value)} className="textareaStyle" placeholder="Any Query"
                                    name="Query"
                                />
                            </div>
                        </div>
                        <div className='col-md-12 mt-4 mb-3'>
                            <button type='submit' className="default-btn w-100 rounded">
                                Submit
                            </button>
                        </div>
                        </div>
                    </form>


                </div>
                </div>
                {/* <------------- Query List  */}
                {
                    SupportList?.length > 0 && (
                        <div className='mt-5'>
                            <Table striped bordered hover>
                                <thead>
                                    <tr>
                                        <th>No of Query</th>
                                        <th>Your Query</th>
                                        <th>Reply</th>
                                        <th>Support file</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        SupportList?.map((SupportListResult, index) => {
                                            return (
                                                <>
                                                    <tr>
                                                        <td>{index + 1}</td>
                                                        <td>{SupportListResult?.user_query}</td>
                                                        <td>{SupportListResult?.admin_response}</td>
                                                        {
                                                             SupportListResult?.support_file && (
                                                                <>
                                                                  <td>
                                                            <a href={SupportListResult?.support_file} target='_blank'><button className='btn btn-primary'>View</button></a>
                                                            </td>
                                                                </>
                                                             )   
                                                        }
                                                    </tr>
                                                </>
                                            )
                                        })
                                    }
                                </tbody>
                            </Table>
                        </div>
                    )
                }

            </div>
            </div>
            <Student_Footer/>
        </>

    )
}

export default Student_Support